const m01Section = {
  id: 'm01',
  name: '2027ScoresheetM01Sub1Label',
  fields: [
    {
      id: 'm01_scoring_1',
      scoring: '2027ScoresheetM01Sub2Label', 
      options: [
        {
          description: 'noLabel',
          value: false
        },
        {
            description: 'yesLabel',
            value: true
        }
      ]
    },
    {
        scoring: '2027ScoresheetM01Sub3Label',
        id: 'm01_scoring_2',
        options: [
            {
                description: 'noLabel',
                value: false
            },
            {
                description: 'yesLabel',
                value: true
            }
        ]
    },
  ]
}

export default m01Section;